<template lang="pug">
  div.row
    el-col(:span="11")
      el-checkbox(:label="label", v-model="checked" v-on:change="changeCheckbox")
        div.text
          slot
      el-select(v-if="label === 'alzheimer' || label === 'psychiatric'", v-model.number="diseaseSevere", placeholder="เลือกระดับ", :disabled="!checked", style="width: 130px;")
        el-option(key=1, label='ระดับ 1', value=1)
        el-option(key=2, label='ระดับ 2', value=2)
      el-row(style="margin-left: 25px;" v-if="label === 'alzheimer' && checked")
        el-checkbox-group(v-model="subDiseases", @change="updateDisease($event)").group-vertical
          el-checkbox(label="forgetful" style="margin-top: 14px;") {{ transformToDisplayable({ name: 'alzheimer', value: 'forgetful' }) }}
          el-checkbox(label="abusive" style="margin-top: 6px;") {{ transformToDisplayable({ name: 'alzheimer', value: 'abusive' }) }}
          el-checkbox(label="sleepProblem" style="margin-top: 6px;") {{ transformToDisplayable({ name: 'alzheimer', value: 'sleepProblem' }) }}
      el-row(style="margin-left: 25px;" v-else-if="label === 'kidneyFailure' && checked")
        el-checkbox-group(v-model="subDiseases", @change="updateDisease($event)").group-vertical
          el-checkbox(label="homeDialysis" style="margin-top: 14px;") {{ transformToDisplayable({ name: 'kidneyFailure', value: 'homeDialysis' }) }}
          el-checkbox(label="hospitalDialysis" style="margin-top: 6px;") {{ transformToDisplayable({ name: 'kidneyFailure', value: 'hospitalDialysis' }) }}
      el-row(style="margin-left: 25px;" v-else-if="label === 'psychiatric' && checked")
        el-checkbox-group(v-model="subDiseases", @change="updateDisease($event)").group-vertical
          el-checkbox(label="abusive" style="margin-top: 14px;") {{ transformToDisplayable({ name: 'psychiatric', value: 'abusive' }) }}
          el-checkbox(label="sleepProblem" style="margin-top: 6px;") {{ transformToDisplayable({ name: 'psychiatric', value: 'sleepProblem' }) }}
    el-col(:span="12")
      el-input(v-model="input", v-on:input="updateDisease($event)", :disabled="!checked")
</template>
<style lang="scss" scoped>
  .row {
    display: flex;
    justify-content: space-between;
    margin-bottom: 7px;
  }

  .text {
    color: #606266;
    font-size: 18px;
    font-weight: 400;
    line-height: 2.2;
  }

  .el-checkbox {
    margin-right: 10px
  }

  .el-checkbox+.el-checkbox {
    margin-left: 0px;
  }

  .group-vertical {
    display: flex;
    flex-direction: column;
  }

</style>

<script>
import { Readable } from '@/model/ModelUtil'

export default {
  name: 'diseaseCheckbox',
  props: {
    label: {
      type: String,
    },
    diseases: {
      type: Array,
    },
  },
  data () {
    return {
      checked: false,
      input: '',
      localDiseases: [],
      subDiseases: [],
      subDisease: null,
      diseaseSevere: null,
    }
  },
  watch: {
    diseases (newDiesease, oldDiesease) {
      this.localDiseases = newDiesease
      const item = newDiesease.filter((item) => {
        return item.name === this.label
      })
      if (item[0]) {
        this.input = item[0].note
        this.checked = true
        if (this.subDiseases.length === 0) {
          if (item[0].homeDialysis) this.subDiseases.push('homeDialysis')
          if (item[0].hospitalDialysis) this.subDiseases.push('hospitalDialysis')
          if (item[0].abusive) this.subDiseases.push('abusive')
          if (item[0].sleepProblem) this.subDiseases.push('sleepProblem')
          if (item[0].forgetful) this.subDiseases.push('forgetful')
        }
      }
    },
    subDiseases (newDiesease, oldDiesease) {
      if (newDiesease.length > 0) {
        this.diseaseSevere = 2
      }
    },
    diseaseSevere (newSevere, oldSevere) {
      if (oldSevere === 2 && newSevere === 1) {
        this.subDiseases = []
      }
      this.updateDisease()
    },
  },
  methods: {
    transformToDisplayable (disease) {
      switch (disease.name) {
        case 'kidneyFailure':
          return Readable.subDisease.fromKidneyFailure(disease.value)
        case 'alzheimer':
          return Readable.subDisease.fromAlzheimer(disease.value)
        case 'psychiatric':
          return Readable.subDisease.fromPsychiatric(disease.value)
      }
    },
    makeObjectDiseases (disease) {
      switch (disease) {
        case 'kidneyFailure':
          return {
            'homeDialysis': false,
            'hospitalDialysis': false,
          }
        case 'psychiatric':
          return {
            'abusive': false,
            'sleepProblem': false,
            'severe': this.diseaseSevere === 2,
          }
        case 'alzheimer':
          return {
            'forgetful': false,
            'abusive': false,
            'sleepProblem': false,
            'severe': this.diseaseSevere === 2,
          }
      }
    },
    updateDisease (event) {
      this.removeDisease()

      this.subDisease = this.makeObjectDiseases(this.label)
      for (let i = 0; i < this.subDiseases.length; i++) {
        this.subDisease[this.subDiseases[i]] = true
      }

      if (this.subDisease) {
        this.localDiseases.push(Object.assign({ name: this.label, note: this.input }, this.subDisease))
      } else {
        this.localDiseases.push({ name: this.label, note: this.input })
      }

      this.$emit('update:diseases', this.localDiseases)
    },
    changeCheckbox (state) {
      if (this.checked === false) {
        this.input = ''
        this.removeDisease()
        this.$emit('update:diseases', this.localDiseases)
      } else {
        this.updateDisease()
      }
    },
    removeDisease () {
      this.localDiseases = this.localDiseases.filter((item) => {
        return item.name !== this.label
      })
    },
  },
}
</script>
